import {
  createArrayValidator,
  createComposedValidator,
  createObjectValidator,
  validateNumber,
  validateString
} from "../../../../packages/validator/validator.js";
import { Month } from "../date/Month.js";
import { validateMonth } from "../date/validateMonth.js";
import { validateYear } from "../date/validateYear.js";
import { QueryItem, validateQueryItem } from "../query/QueryItem.js";
import { BaseRateTaxedAmount, validateBaseRateTaxedAmount } from "./BaseRateTaxedAmount.js";
import { VatReturn, validateVatReturn } from "./VatReturn.js";
import { ZeroRateTaxedAmount, validateZeroRateTaxedAmount } from "./ZeroRateTaxedAmount.js";

/**
 * Contains VAT report for one month.
 */
export type VatReport = {
  year: string;
  month: Month;
  /**
   * Field 1. Amount taxed with base rate.
   */
  vatBaseTaxedAmount: BaseRateTaxedAmount;
  /**
   * Field 3.
   */
  vatZeroTaxedAmount: ZeroRateTaxedAmount;
  /**
   * Field 4. Total VAT. Must be "vatBaseTaxedAmount.total" x 0.24.
   */
  vatTotal: number;
  /**
   * Field 5. Amount of VAT to be returned.
   */
  vatReturn: VatReturn;
  /**
   * Field 6. Expenses from non-Estonian EU companies to be reverse charged.
   */
  expensesEu: number;
  /**
   * Items associated with field 6.
   */
  expensesEuItems: QueryItem[];
  /**
   * Field 12. VAT to be paid.
   */
  vatExpense: number;
  /**
   * Field 13. VAT to be returned.
   */
  vatIncome: number;

  /**
   * VAT liability account balance.
   */
  vatAccountBalance: number;
};

export const validateVatReport = createObjectValidator<VatReport>("VatReport", {
  year: createComposedValidator(validateString, (value: unknown) => validateYear(value as string)),
  month: createComposedValidator(validateString, (value: unknown) => validateMonth(value as string)),
  vatBaseTaxedAmount: validateBaseRateTaxedAmount,
  vatZeroTaxedAmount: validateZeroRateTaxedAmount,
  vatTotal: validateNumber,
  vatReturn: validateVatReturn,
  expensesEu: validateNumber,
  expensesEuItems: createArrayValidator(validateQueryItem),
  vatExpense: validateNumber,
  vatIncome: validateNumber,
  vatAccountBalance: validateNumber
});
